import { IonicModule } from '@ionic/angular';

import { NO_ERRORS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { RouteReuseStrategy } from '@angular/router';
import { IonicRouteStrategy } from '@ionic/angular';

import { AppRoutingModule } from './app-routing.module';

import { AppComponent } from './app.component';
import { LoginComponent } from './components/shared/login/login.component';
import { AdminHomeComponent } from './components/admin/home/admin-home.component';
import { ClientHomeComponent } from './components/client/home/client-home.component';

import { AuthenticationService } from './services/authentication.service';
import { ApiProviderService } from './services/api-provider.service';

import { Interceptor } from './helpers/Interceptor';
import { AuthGuardAdmin } from './helpers/AuthGuardAdmin';
import { AuthGuardUser } from './helpers/AuthGuardUser';
import { AuthGuardCoach } from './helpers/AuthGuardCoach';



import { CoachformComponent } from './components/Coach/account/coachform/coachform.component';
import { ListCoachComponent } from './components/admin/coach/list-coach/list-coach.component';
import { ListUserComponent } from './components/Coach/client/list-user/list-user.component';
import { UserFormComponent } from './components/Coach/client/user-form/user-form.component';
import { CoachHomeComponent } from './components/Coach/home/coach-home.component';
import { SessionFormComponent } from './components/Coach/sessions/form-session/session-form.component';
import { ListSessionComponent } from './components/Coach/sessions/list-session/list-session.component';
import { ListClientSelectableComponent } from './components/Coach/client/list-client-selectable/list-client-selectable.component';
import { FormuleFormComponent } from './components/Coach/formules/formule-form/formule-form.component';
import { ListAddressComponent } from './components/Coach/address/list-address/list-address.component';
import { FromAddressComponent } from './components/Coach/address/form-address/from-address.component';
import { ListAddressSelectableComponent } from './components/Coach/address/list-address-selectable/list-address-selectable.component';
import { HelperService } from './services/helper.service';
import { DatePipe, registerLocaleData } from '@angular/common';
import localeFrCa from '@angular/common/locales/fr-CA';
import localeFrCaExtra from '@angular/common/locales/extra/fr-CA';
import { ListFormuleComponent } from './components/Coach/formules/list-formule/list-formule.component';
import { DashboardComponent } from './components/Coach/dashboards/dashboard/dashboard.component';
import { PageClientComponent } from './components/Coach/client/page-client/page-client.component';
import { AbonnementFormComponent } from './components/Coach/abonnement-form/abonnement-form.component';


import { AlreadySessionComponent } from './components/shared/modals/already-session/already-session.component';
import { ViewSessionComponent } from './components/shared/modals/view-session/view-session.component';
import { DashboardFinanceComponent } from './components/Coach/dashboards/dashboard-finance/dashboard-finance.component';
import { FormPaymentComponent } from './components/Coach/bills/form-payment/form-payment.component';
import { ListDayComponent } from './components/Coach/sessions/list-day/list-day.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ListSessionBisComponent } from './components/Coach/sessions/list-session-bis/list-session-bis.component';
import { SessionsService } from './services/sessions.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { NextAppointmentComponent } from './components/Coach/widgets/next-appointment/next-appointment.component';
import { MyClientComponent } from './components/Coach/widgets/my-client/my-client.component';
import { LOCALE_ID} from '@angular/core';
import { AuthProviderService } from './services/api-providers/auth-provider.service';
import { FormInscriptionComponent } from './components/shared/form-inscription/form-inscription.component';
import { FormBillsComponent } from './components/Coach/bills/form-bills/form-bills.component';
import { LastPaymentsListComponent } from './components/Coach/widgets/last-payments-list/last-payments-list.component';
import { SomeInfosComponent } from './components/Coach/widgets/some-infos/some-infos.component';
import { WidgetFinanceComponent } from './components/Coach/widgets/widget-finance/widget-finance.component';
import { PackageApiService } from './micro-services/packages/package-api.service';
import { ListPackageComponent } from './components/admin/package/list-package/list-package.component';
import { FormPackageComponent } from './components/admin/package/form-package/form-package.component';
import { YesNoModalComponent } from './components/shared/modals/yes-no-modal/yes-no-modal.component';
import { PackagePlatformService } from './micro-services/packages/services/package-plateform.service';
import { PackageFactoryService } from './micro-services/packages/services/package-factory.service';
import { FormCoachComponent } from './components/admin/coach/form-coach/form-coach.component';
import { InformationComponent } from './components/Coach/account/information/information.component';
import { SubscribeComponent } from './components/Coach/account/subscribe/subscribe.component';
import { SubscriptionFactoryService } from './micro-services/subscription/services/subscription-factory.service';
import { SubscriptionApiService } from './micro-services/subscription/subscription-api.service';
import { SubscriptionPlateformService } from './micro-services/subscription/services/subscription-plateform.service';
import { UserFactory } from './micro-services/user/user-factory';
import { AccountComponent } from './components/Coach/account/account.component';
import { SelectPackageComponent } from './components/shared/modals/select-package/select-package.component';
import { PaymentsListComponent } from './components/Coach/bills/payments-list/payments-list.component';
import { NoteComponent } from './components/shared/modals/note/note.component';
import { SiteComponent } from './components/site/site.component';
import { ForgotPasswordComponent } from './components/shared/forgot-password/forgot-password.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ObjectiveClientComponent } from './components/Coach/client/objective-client/objective-client.component';
import { ObjectiveFormComponent } from './components/Coach/client/objective-client/objective-form/objective-form.component';
import { ObjectivePageComponent } from './components/Coach/client/objective-client/objective-page/objective-page.component';
import { ProgressModalComponent } from './components/Coach/client/objective-client/progression-modal/progress-modal.component';
import { AdressPopoverComponent } from './components/shared/modals/adress-popover/adress-popover.component';
import { PackageSubscriptionDetailsComponent } from './components/shared/modals/package-subscription-details/package-subscription-details.component';
import { StatusPipe } from './pipes/status-pipe';
import { ReportComponent } from './components/shared/report/report.component';
import { ContactComponent } from './components/Coach/account/contact/contact.component';
import { CguComponent } from './components/Coach/account/cgu/cgu.component';
import { CgvComponent } from './components/Coach/account/cgv/cgv.component';
import { PolitiqueComponent } from './components/Coach/account/politique/politique.component';
import { MentionsComponent } from './components/Coach/account/mentions/mentions.component';
import { LandingPageComponent } from './components/landing-page/landing-page.component';
import { ObjectiveTypeTooltipModalComponent } from './components/Coach/client/objective-client/objective-type-tooltip-modal/objective-type-tooltip-modal.component';
import { AboutComponent } from './components/Coach/account/about/about.component';
import { Device } from '@awesome-cordova-plugins/device/ngx';
import { AppVersion } from '@awesome-cordova-plugins/app-version/ngx';
import { NotificationPushService } from './micro-services/notifications/services/notification-push.service';
import { SQLite } from '@awesome-cordova-plugins/sqlite/ngx';
import { SQLitePorter } from '@awesome-cordova-plugins/sqlite-porter/ngx';

registerLocaleData(localeFrCa, localeFrCaExtra);


@NgModule({ schemas: [
        NO_ERRORS_SCHEMA, // Add the NO_ERRORS_SCHEMA here
    ],
    declarations: [
        AppComponent,
        LoginComponent,
        AdminHomeComponent,
        ClientHomeComponent,
        CoachHomeComponent,
        ListCoachComponent,
        ListUserComponent,
        ListSessionComponent,
        ListSessionBisComponent,
        ListAddressComponent,
        ListClientSelectableComponent,
        ListAddressSelectableComponent,
        ListFormuleComponent,
        ListClientSelectableComponent,
        CoachformComponent,
        UserFormComponent,
        SessionFormComponent,
        FormuleFormComponent,
        FromAddressComponent,
        DashboardComponent,
        AlreadySessionComponent,
        ViewSessionComponent,
        PageClientComponent,
        AbonnementFormComponent,
        AlreadySessionComponent,
        ViewSessionComponent,
        DashboardFinanceComponent,
        ListDayComponent,
        FormPaymentComponent,
        NextAppointmentComponent,
        MyClientComponent,
        FormInscriptionComponent,
        FormBillsComponent,
        LastPaymentsListComponent,
        SomeInfosComponent,
        WidgetFinanceComponent,
        ListPackageComponent,
        FormPackageComponent,
        YesNoModalComponent,
        FormCoachComponent,
        InformationComponent,
        SubscribeComponent,
        AccountComponent,
        SelectPackageComponent,
        PaymentsListComponent,
        NoteComponent,
        SiteComponent,
        ForgotPasswordComponent,
        ObjectiveClientComponent,
        ObjectiveFormComponent,
        ObjectivePageComponent,
        ProgressModalComponent,
        AdressPopoverComponent,
        PackageSubscriptionDetailsComponent,
        StatusPipe,
        ReportComponent,
        ContactComponent,
        CguComponent,
        CgvComponent,
        PolitiqueComponent,
        MentionsComponent,
        LandingPageComponent,
        ObjectiveTypeTooltipModalComponent,
        AboutComponent
    ],
    bootstrap: [AppComponent],
    imports: [
        DragDropModule,
        FormsModule,
        BrowserModule,
        AppRoutingModule,
        ReactiveFormsModule,
        IonicModule.forRoot({
            mode: 'md',
            platform: {
                desktop: (win) => {
                    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(win.navigator.userAgent);
                    return !isMobile;
                }
            }
        }),
        NgbModule,
        BrowserAnimationsModule,
        ScrollingModule
    ], 
    providers: [
        { provide: LOCALE_ID, useValue: 'fr-CA' },
        { provide: HTTP_INTERCEPTORS, useClass: Interceptor, multi: true },
        AuthGuardAdmin,
        AuthGuardUser,
        AuthGuardCoach,
        AuthenticationService,
        ApiProviderService,
        SessionsService,
        HelperService,
        DatePipe,
        AuthProviderService,
        PackageApiService,
        PackageFactoryService,
        PackagePlatformService,
        SubscriptionApiService,
        SubscriptionFactoryService,
        SubscriptionPlateformService,
        UserFactory,
        Device,
        AppVersion,
        NotificationPushService,
        SQLite,
        SQLitePorter,
        provideHttpClient(withInterceptorsFromDi()),
        { provide: RouteReuseStrategy, useClass: IonicRouteStrategy }
    ] })
   
export class AppModule {}
